import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

const IndexPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate({ to: '/vehicles/', replace: true });
  }, [navigate]);

  return <></>;
};

export const Route = createFileRoute('/')({ component: IndexPage });
